import { compose } from 'recompose';

import intlEquipped from '../../../../../hocs/intlEquipped';
import Details from './Details';

export default compose(
    intlEquipped
)(Details);
